const ClaimMethod = ({
    value = '',
    isVerified = false,
} = {}) => ({
    value: String(value),
    isVerified: Boolean(isVerified),
});

export default ClaimMethod;
